import React from "react";
import { values } from "lib";
import style from "./style.module.css";

const TeamsList = ({
  items,
  visibleItemsCount,
  itemClassName,
  moreLink,
  total,
  onItemClick
}) => {
  const ItemNode = ({ id, children }) => (
    <div className={itemClassName} onClick={() => onItemClick(id)}>
      {children}
    </div>
  );

  const itemsArray = values(items).map(item => (
    <ItemNode key={item.id} id={item.id}>
      {item.name}
    </ItemNode>
  ));

  if (!items) return null;

  if (itemsArray.length === 1) return itemsArray[0];

  if (itemsArray.length < visibleItemsCount) {
    const commaItemsArray = itemsArray
      .slice(0, itemsArray.length - 2)
      .map(item => [item, ", "]);

    return (
      <div className={style.wrap}>
        {commaItemsArray}
        {itemsArray[itemsArray.length - 2]}
        {" & "}
        {itemsArray[itemsArray.length - 1]}
      </div>
    );
  }

  const visibleItemsArray = itemsArray
    .slice(0, visibleItemsCount - 2)
    .map(item => [item, ", "]);

  const restOfItemsArray = itemsArray.slice(visibleItemsCount - 2);

  const lastItemCount = total
    ? total - visibleItemsArray.length - 2
    : restOfItemsArray.length - 1;

  const lastItem = (
    <div className={itemClassName} style={{ cursor: "auto" }}>
      + {lastItemCount} more
    </div>
  );

  return (
    <div className={`${style.wrap} notranslate`}>
      {visibleItemsArray}
      {restOfItemsArray[0]} {lastItem}
    </div>
  );
};

export default TeamsList;
